import client from "./client";

const getTransactionsSummary = (currency) =>
  client.get(`/subsidiary/metric/transaction/summary?currency=${currency}`);

export default { getTransactionsSummary };
